/**
 * @Author: v_jppjpeng
 * @Date: 2024-08-16 17:04:26
 * @Explain: 活动 - 埋点事件
 */
export default {
  /** 删除分层 */
  130: 'clickDeleteSegmentError',
  /** 创建、编辑分层 - 提交验证错误 */
  131: 'clickSubmitVerificationError',
  /** 创建、编辑分层 - 提交错误 */
  132: 'clickSubmitBtnError',
};
